import { render, staticRenderFns } from "./Anomalies.vue?vue&type=template&id=2fd8ab08&scoped=true"
import script from "./Anomalies.vue?vue&type=script&lang=js"
export * from "./Anomalies.vue?vue&type=script&lang=js"
import style0 from "./Anomalies.vue?vue&type=style&index=0&id=2fd8ab08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8ab08",
  null
  
)

export default component.exports